<template>
    <div id="LandingPage">
        <GuidanceVideoModal v-if="show" @closeModal="show = false"></GuidanceVideoModal>
        <div id="headerLandingPage" class="r-headerLanding r-isRelative r-useraccount-container r-center-flex r-primary-bg r-isWrap r-ptb-30">
            <!-- <div class="r-center-flex r-guidance-download">
                <div class="r-isFlex r-mr-10">
                    <img :src="require('@/assets/icons/white/guidance.svg')" alt="download pdf">
                </div>
                <p>
                    <a href="/guidance/Guided-Pencari-Kerja.pdf" download="Guided-Pencari-Kerja">
                        Unduh panduan penggunaan
                    </a>
                    atau
                    <u @click.prevent="show = true">Lihat Video Tutorial</u>
                </p>
            </div> -->
            <div class="r-center-flex r-isExpand r-isWrap">
                <div class="r-mr-auto r-left-headerLanding">
                    <h1 class="r-mtb-16 r-white-text">Welcome to the Career Development Center Unika Atma Jaya</h1>
                    <p class="r-mb-32 r-white-text">We are dedicated to providing a range of services to support the career journeys of Unika Atma Jaya students and alumni. Discover various compelling opportunities for full-time job and internships, career seminars and workshop, and educational resources designed to enhance your insights into the world of careers.</p>
                    <p class="r-mb-32 r-white-text">“Pioneering Your Path to Success”</p>
                </div>
                <div class="r-center-flex r-listDisplay-mobile r-isWrap" :class="isMobile ? 'r-isExpand-mobile' : 'r-mr-auto'">
                    <router-link :to="{name: 'Job Vacancy'}" class="r-mb-20" >
                        <button class="r-primary-textOnly-btn r-white-bg r-large-size">
                            Cari Lowongan
                        </button>
                    </router-link>
                    <span class="r-mlr-10 r-mb-20 r-white-text" v-if="!isMobile">atau</span>
                    <router-link :to="{name: !isLoggedIn ? 'Registration' : 'Company List'}" class="r-mb-20" >
                        <button class="r-secondary-filled-btn r-large-size">
                            {{!isLoggedIn ? 'Cari Talent Baru' : 'Lihat Perusahaan'}}
                        </button>
                    </router-link>
                </div>
            </div>
        </div>
        <Carousel />
        <section class="r-announcement r-useraccount-container r-mtb-20">
            <div class="r-center-flex">
                <h3 class="r-mr-auto">Informasi</h3>
                <router-link :to="{name: 'announcementList'}" class="r-center-flex" v-if="announcements.length > 4">
                    <strong class="r-primary-text r-mr-8">Lainnya</strong>
                    <img :src="require('@/assets/icons/primary/arrow-right2.svg')" alt="arrow-right">
                </router-link>
            </div>
            <div class="r-company-empty r-fullcenter-flex r-isExpand r-mt-25 "  v-if="announcementList.length == 0 && loading == null">
                <div class="r-flex-column" >
                    <img class="r-56-square" :src="require('@/assets/landing/404.svg')" alt="" >
                    <h5 class="r-700">Belum ada informasi</h5>
                </div>
            </div>
            <div class="r-center-flex r-mt-25">
                <div class="r-columns r-isFlex r-isWrap r-isExpand">
                    <template v-if="loading == 'getData'">
                        <div class="r-m-8 r-column-4" v-for="i in 4" :key="`announcement-loading-${i}`">
                            <announcementCardLoading ></announcementCardLoading>
                        </div>
                    </template>
                    <template v-else>
                        <div class="r-m-8 r-column-4" v-for="(a, i) in announcementList" :key="`announcement-${i}`">
                            <announcementCard :data="a"></announcementCard>
                        </div>
                    </template>
                </div>
            </div>
        </section>

        <div class="r-companyList r-useraccount-container r-landing-padding">
            <div class="r-title-section">
                <h3 class="r-center-text">Daftar Perusahaan</h3>
                <hr class="r-line-section">
            </div>
            <div class="r-company-empty r-fullcenter-flex" v-if="companies.length == 0">
                <div class="r-flex-column">
                    <img class="r-56-square" :src="require('@/assets/empty.svg')" alt="">
                    <h5 class="r-700">Belum Ada Daftar Perusahaan</h5>
                    <p class="r-black-60-text">Kami akan segera memperbaharui daftar perusahaan</p>
                </div>
            </div>

            <template v-else>
                <div class="r-companylist r-isFlex r-isWrap">
                    <div class="r-companyItem r-fullcenter-flex" 
                        v-for="(company, index) in filterCompanies" :key="`perusahaan-${index}`">
                        <router-link  :to="{name: 'Company Detail', params: {slug: company.slug}}">
                            <img :src="company.logo" :alt="company.name">
                        </router-link>
                    </div>
                </div>
                <div class="r-isFlex" v-if="companies.length > 18">
                    <button class="r-primary-filled-btn r-large-size r-mtb-16 r-mlr-auto" @click.prevent="companyShowMore = !companyShowMore">
                        Lihat Lebih {{ companyShowMore ? 'Sedikit' : 'Banyak'}}
                    </button>
                </div>
            </template>
            
        </div>

         <div class="r-useraccount-container r-landing-padding">
            <div class="r-title-section">
                <h3 class="r-center-text">FAQ</h3>
                <hr class="r-line-section">
            </div>
            
            <div class="r-faq">
                <faqCard 
                    v-for="(f,i) in faqs" 
                    :key="`faq-${i}`" 
                    :show="isExists(i)"
                    :data="f"
                    @click.prevent="setFaq(i)"
                ></faqCard>
            </div>
        </div>

    </div>
</template>
<script>
import {yearOnly, commonDateTimeFormat, compareDate} from '@/common/timeformat'
import common from '@/mixins/common'
import { mapGetters, mapActions } from "vuex"
import announcementCard from '@/components/main/announcementCard'
import announcementCardLoading from '@/components/main/announcementCardLoading'
import Carousel from '@/components/main/Carousel'
import faqCard from '@/components/main/faqCard'
import GuidanceVideoModal from '@/components/modal/GuidanceVideoModal'

export default {
    mixins: [common],
    mounted(){
        this.initData()
    },
    components:{
        announcementCard,
        announcementCardLoading,
        Carousel,
        faqCard,
        GuidanceVideoModal
    },
    computed: {
        ...mapGetters({
            companies: 'eventData/getCompanies',
            role: 'auth/getRole',
            user: 'auth/getUser',
            announcements: 'announcement/getLanding',
            faqs: 'faqManage/getFaqs'
        }),
        announcementList(){
            return this.announcements.filter((row, i) => i < 4)
        },
        filterCompanies(){
            if(this.companyShowMore) return this.companies
            return this.companies.filter((row, i) => i < 18)
        }
    },
    data: () => ({
        show: false,
        companyShowMore: false,
        showFaq: [],
        loading: 'getData',
        alpha: [
            {
                left: 'slide1',
                right: 'slide1'
            },
            {
                left: 'slide2',
                right: 'slide2'
            },
            {
                left: 'slide1',
                right: 'slide1'
            },
            {
                left: 'slide2',
                right: 'slide2'
            },
        ],
    }),
    methods:{
        ...mapActions({
            getCompaniesData: 'eventData/getCompaniesData',
            getAnnounData: 'announcement/getLandingData',
            getFaq: 'faqManage/getfaqsData'
        }),
        async initData(){
            this.loading = 'getData'
            await this.getCompaniesData()
            await this.getAnnounData()
            this.loading = 'faq'
            await this.getFaq()
            this.loading = null
            /*  if(this.user.verify_email && this.role=='jobseeker' ){
                    this.$store.dispatch('setModal','JobSeekerEvaluation')
                    return
                }*/
        },
        yearOnly(){
            return yearOnly(new Date())
        },
        commonDateTimeFormat(value){
            return commonDateTimeFormat(value)
        },
        compareDate(begin,end){
            return compareDate(begin, end)
        },
        isExists(i){
            return this.showFaq.some(x => x == i)
        },
        setFaq(i){
            if(this.isExists(i)){
                const temp = this.showFaq.filter(row => row != i)
                this.showFaq = temp
            }else{
                this.showFaq.push(i)
            }
        }
    }
}
</script>